"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOOLS_DB_TABS = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_router_1 = require("react-router");
var NavTabs_1 = __importDefault(require("atomicComponents/atoms/NavTabs/NavTabs"));
var NavTabsContainer_1 = __importDefault(require("atomicComponents/atoms/NavTabs/NavTabsContainer"));
var ButtonWithModal_1 = __importDefault(require("atomicComponents/organisms/Button/ButtonWithModal"));
var SearchBar_1 = __importDefault(require("../SearchBar"));
var AddNewToolModal_1 = __importDefault(require("./AddNewToolModal"));
exports.TOOLS_DB_TABS = [
    { label: 'Tools', href: '/admin/tools-database' },
    { label: 'Naming', href: '/admin/naming' },
    { label: 'Uncurated', href: '/admin/uncurated' },
];
var ToolsDBMenu = function (_a) {
    var searchText = _a.searchText, setSearchText = _a.setSearchText, setSelectedServiceId = _a.setSelectedServiceId, hasPreview = _a.hasPreview;
    var location = (0, react_router_1.useLocation)();
    var tabsOnPreview = __spreadArray(__spreadArray([], __read(exports.TOOLS_DB_TABS.filter(function (t) { return location.pathname === t.href; })), false), [{ label: 'close preview' }], false);
    return ((0, jsx_runtime_1.jsxs)(NavTabsContainer_1.default, __assign({ width: "auto", display: "flex", alignItems: "center", justifyContent: "space-between" }, { children: [(0, jsx_runtime_1.jsx)(NavTabs_1.default, { tabs: hasPreview ? tabsOnPreview : exports.TOOLS_DB_TABS, onClick: function () { return setSelectedServiceId(null); } }), !hasPreview && ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", justifyContent: "flex-end", alignItems: "center", mr: 6 }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mr: 1 }, { children: (0, jsx_runtime_1.jsx)(ButtonWithModal_1.default, __assign({ renderOnlyOnOpen: true, modalComponent: AddNewToolModal_1.default }, { children: "Add new tool" })) })), (0, jsx_runtime_1.jsx)(SearchBar_1.default, { searchText: searchText, setSearchText: setSearchText })] })))] })));
};
exports.default = ToolsDBMenu;
